import {
  TablePage,
} from 'src/views/abi/activitylog'
import pathMap from 'src/paths/pathMap'

class AbiActivityLogRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ABI_ACTIVITY_LOG_PATH,
        component: TablePage
      }
    ]
  }
}

export default AbiActivityLogRoute
